import { TextField, Button, FormControl, Grid } from '@mui/material';
import { ArrowRightCircle, Save } from 'react-feather';

import { CustomAutocomplete, LinearLoading } from 'common'

export const GeneralInfoStep = ({ useFetchInit, readOnlyMode }) => {

    const {
        Forms,
        FetchData,
        Actions
    } = useFetchInit

    const { FormScreen } = Forms
    const { formState, onInputChange, onSelectSearchChange } = FormScreen
    
    const { 
        fetchSpecificLegalDocument,
        fetchProcessType,
        fetchProcessLawyer
    } = FetchData
    const { loadingFetchSpecificLegalDocument } = fetchSpecificLegalDocument
    const { dataProcessType } = fetchProcessType
    const { dataProcessLawyer } = fetchProcessLawyer

    const {
        onSubmitForm,
        handleClickContinue
    } = Actions
    
    return (
        <>
            
            <div className='h4 mt-1 mb-1'>
                {formState.iddocument > 0
                    ? 'Visualizar Registro'
                    : 'Crear Registro'}
            </div>
            <div className="border-bottom border-dark"></div>
            {loadingFetchSpecificLegalDocument && ( <LinearLoading /> )}

            <div className="pt-2"></div>
            <form onSubmit={onSubmitForm}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="date_document">* Fecha</label>
                            <TextField
                                id="date_document"
                                name="date_document"
                                value={formState.date_document}
                                onChange={onInputChange}
                                size='small'
                                type="date"
                                variant="outlined"
                                hiddenLabel
                                disabled={readOnlyMode}
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="idprocesstype">* Documento</label>
                            <CustomAutocomplete 
                                customId="idprocesstype"
                                customName="idprocesstype"
                                customValue={formState.idprocesstype}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idprocesstype', value: value.value }})}
                                customPlaceholder='Selecciona una opcion'
                                customOptions={
                                    dataProcessType.map(({ idprocesstype, name_process, category, type }) => ({
                                        value: idprocesstype,
                                        name: name_process
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={readOnlyMode}
                                customRequired={true}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="idlawyer">Proceso</label>
                            <CustomAutocomplete 
                                customId="idlawyer"
                                customName="idlawyer"
                                customValue={formState.idlawyer}
                                customOnChange={(target, value) => onSelectSearchChange({ target: { name: 'idlawyer', value: value.value }})}
                                customPlaceholder='Selecciona una opcion'
                                customOptions={
                                    dataProcessLawyer.map(({ idlawyer, process_number, jdo_process_number }) => ({
                                        value: idlawyer,
                                        name: `${process_number} - ${jdo_process_number}`
                                    }))
                                }
                                customDisableClearable={true}
                                customDisabled={readOnlyMode}
                                customRequired={false}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <div className="pt-2"></div>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl fullWidth>
                            <label htmlFor="observations">Observaciones</label>
                            <TextField
                                id="observations"
                                name="observations"
                                value={formState.observations}
                                onChange={onInputChange}
                                size='small'
                                multiline
                                rows={3}
                                type="text"
                                variant="outlined"
                                disabled={readOnlyMode}
                                InputProps={{
                                    readOnly: readOnlyMode,
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <div className="pt-4"></div>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '100%' }}>                
                    <Grid item xs={12}>
                        <div className="text-center">
                            <Button
                                variant="contained"
                                type="submit"
                                disabled={readOnlyMode}
                                style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                            >
                                <Save />
                            </Button>
                            &nbsp;
                            {(formState.iddocument > 0)&&(
                                <Button
                                    variant="contained"
                                    type="button"
                                    onClick={handleClickContinue}
                                    style={{ marginRight: 2, marginLeft: 2, background: "#4b4b4c" }}
                                >
                                    <ArrowRightCircle/>
                                </Button>
                            )}
                        </div>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}
